import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import {
  getReviewThreads,
  type PaginatedResponse,
  type ReviewSubjectType,
  type ReviewThreadListItemModel,
  type ReviewThreadStatus,
} from "@/api/cle-api";

export interface UseReviewThreadsParams {
  status?: ReviewThreadStatus[];
  ownerUserId?: string;
  assignedAdminUserId?: string;
  assignedAdminEmail?: string;
  subjectType?: ReviewSubjectType[];
  assignedTo?: boolean;
  page?: number;
  pageSize?: number;
}

export const reviewThreadsQueryKey = ({
  status,
  ownerUserId,
  assignedAdminUserId,
  assignedAdminEmail,
  subjectType,
  assignedTo,
  page = 1,
  pageSize = 20,
}: UseReviewThreadsParams) =>
  [
    "cle-api",
    "admin",
    "review-threads",
    status?.slice().sort(),
    ownerUserId,
    assignedAdminUserId,
    assignedAdminEmail,
    subjectType?.slice().sort(),
    assignedTo,
    page,
    pageSize,
  ] as const;

export const useReviewThreads = ({
  status,
  ownerUserId,
  assignedAdminUserId,
  assignedAdminEmail,
  subjectType,
  assignedTo,
  page = 1,
  pageSize = 20,
}: UseReviewThreadsParams): UseQueryResult<
  PaginatedResponse<ReviewThreadListItemModel>,
  Error
> =>
  useQuery({
    queryKey: reviewThreadsQueryKey({
      status,
      ownerUserId,
      assignedAdminUserId,
      assignedAdminEmail,
      subjectType,
      assignedTo,
      page,
      pageSize,
    }),
    queryFn: () =>
      getReviewThreads({
        status,
        ownerUserId,
        assignedAdminUserId,
        assignedAdminEmail,
        subjectType,
        assignedTo,
        page,
        pageSize,
      }),
    staleTime: 30_000,
    refetchOnWindowFocus: false,
  });
